import React, { useEffect, useState } from "react";
import IconsGen from "../../../icons_generator/IconsGen";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Loader from "../../../loader/Loader";
import AxiosController from "../../../authentication/AxiosController";
import { Helmet } from "react-helmet";
import DateRangePickerComponent from "../../../date/DateRangePickerComponent";
import { format } from "date-fns";
import BlueRow from "../../wallet/WalletComp/BlueRow";
import OrangeRow from "../../wallet/WalletComp/OrangeRow";
import PaymentRequests from "../../wallet/WalletComp/PaymentRequests";

const get_Fulfillment_Earning = (
  slug,
  lang,
  token,
  handleLoader,
  handleFulfillmentData,
  dates = {}
) => {
  AxiosController.get(`api/${slug}/${lang}/fulfillments/reports/incomes`, {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      start: dates["start"] ? dates["start"] : "",
      end: dates["end"] ? dates["end"] : "",
    },
  })
    .then((res) => {
      handleFulfillmentData(res.data);
      handleLoader(false);
    })
    .catch((e) => {
      handleLoader(false);
    });
};

const get_Fulfillment_Reports = (
  slug,
  lang,
  token,
  handleLoader,
  handleReportsData,
  dates = {}
) => {
  const params = {};
  if (dates["start"]) params.start_date = dates["start"];
  if (dates["end"]) params.end_date = dates["end"];

  AxiosController.get(`api/${slug}/${lang}/fulfillments/reports`, {
    headers: { Authorization: `Bearer ${token}` },
    params: params,
  })
    .then((res) => {
      handleReportsData(res.data);
      handleLoader(false);
    })
    .catch((e) => {
      handleLoader(false);
    });
};

const control_panel_stats_wallet = (
  slug,
  lang,
  token,
  handleStatsWallet,
  handleAltName,
  handleLoader,
  dates = {}
) => {
  AxiosController.get(`api/${slug}/${lang}/get-control-panel-stats-wallet/`, {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      start: dates["start"] ? dates["start"] : "",
      end: dates["end"] ? dates["end"] : "",
    },
  })
    .then((res) => {
      handleStatsWallet(res.data);
      handleAltName(res.data.alt_name);
      handleLoader(false);
    })
    .catch((e) => {});
};

const FulfillmentEarnings = () => {
  const { slug, lang } = useParams();
  const [_] = useTranslation("global");
  const box_head_dir = lang === "en" ? "ltr" : "rtl";
  const token = localStorage.getItem("token");
  const [loading, handleLoader] = useState(false);
  const [fulfillmentData, setFulfillmentData] = useState({});
  const [reportsData, setReportsData] = useState({});
  const [activeTab, setActiveTab] = useState("earnings");

  const [state, setState] = useState({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  });

  const applyDateRange = () => {
    const { startDate, endDate } = state.selection;
    const formattedStartDate = new Date(startDate.setHours(0, 0, 0, 0));
    const formattedEndDate = new Date(endDate.setHours(0, 0, 0, 0));

    const apiStartDate = format(formattedStartDate, "yyyy-MM-dd");
    const apiEndDate = format(formattedEndDate, "yyyy-MM-dd");
    handleLoader(true);

    get_Fulfillment_Earning(
      slug,
      lang,
      token,
      handleLoader,
      setFulfillmentData,
      { start: apiStartDate, end: apiEndDate }
    );
    get_Fulfillment_Reports(slug, lang, token, handleLoader, setReportsData, {
      start: apiStartDate,
      end: apiEndDate,
    });
  };

  useEffect(() => {
    get_Fulfillment_Earning(
      slug,
      lang,
      token,
      handleLoader,
      setFulfillmentData
    );
    get_Fulfillment_Reports(slug, lang, token, handleLoader, setReportsData);
  }, [slug, lang, token]);

  return (
    <div className="flex-grow-1 stats-component">
      <Helmet>
        <title>{_("panel.earning")}</title>
      </Helmet>
      <div className="reports-container my-3 d-flex flex-column gap-2 px-2 position-relative ">
        <Loader active={loading} />
        <div className="reports-header d-flex flex-column flex-md-row py-2 justify-content-between flex-wrap">
          <h3 style={{ color: "rgba(23, 43, 77, 1)" }}>{_("panel.earning")}</h3>
        </div>

        {/* Tab Navigation */}
        <div className="tab-navigation d-flex gap-2 mb-3">
          <button
            className={`tab-button px-3 py-2 border-0 rounded ${
              activeTab === "earnings" ? "active" : ""
            }`}
            onClick={() => setActiveTab("earnings")}
            style={{
              backgroundColor:
                activeTab === "earnings" ? "#172b4d" : "transparent",
              color: activeTab === "earnings" ? "white" : "#172b4d",
              border: "1px solid #172b4d",
              cursor: "pointer",
            }}
          >
            {_("panel.fulfillmentEarnings")}
          </button>
          <button
            className={`tab-button px-3 py-2 border-0 rounded ${
              activeTab === "reports" ? "active" : ""
            }`}
            onClick={() => setActiveTab("reports")}
            style={{
              backgroundColor:
                activeTab === "reports" ? "#172b4d" : "transparent",
              color: activeTab === "reports" ? "white" : "#172b4d",
              border: "1px solid #172b4d",
              cursor: "pointer",
            }}
          >
            {_("panel.reports")}
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === "reports" && (
          <div className="mb-3 d-flex justify-content-end">
            <DateRangePickerComponent
              state={state}
              setState={setState}
              applyDateRange={() => applyDateRange()}
            />
          </div>
        )}
        <div
          className="boxes-container d-flex flex-wrap gap-2"
          dir={box_head_dir}
        >
          {activeTab === "earnings" ? (
            // Fulfillment-specific metrics
            <>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"bluecheck"} />
                  <p className="flex-grow-1">
                    <p>مؤكد تحصيله</p> <p>( تم التوصيل )</p>{" "}
                  </p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {(
                      fulfillmentData?.income_report?.confirmed || 0
                    ).toLocaleString()}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {Number(
                      fulfillmentData?.income_report?.confirmed_count || 0
                    ).toLocaleString()}
                  </small>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"bluetrans"} />
                  <p className="flex-grow-1">
                    {" "}
                    <p>في انتظار التحصل </p> <p>( قابل للسحب) </p>
                  </p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {(
                      fulfillmentData?.income_report?.pending_transfer || 0
                    ).toLocaleString()}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {Number(
                      fulfillmentData?.income_report?.pending_transfer_count ||
                        0
                    ).toLocaleString()}
                  </small>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"dollarSign"} />
                  <p className="flex-grow-1">
                    <p>اجمالي الدخل</p> <p>( قابل للسحب + تم التسوية ) </p>{" "}
                  </p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {(
                      fulfillmentData?.income_report?.total_cod || 0
                    ).toLocaleString()}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {Number(
                      fulfillmentData?.income_report?.total_cod_count || 0
                    ).toLocaleString()}
                  </small>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"orangdash"} />
                  <p className="flex-grow-1">تم التحصيل</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {(
                      parseFloat(
                        fulfillmentData?.payment_requests?.withdrawn
                      ) || 0
                    ).toLocaleString()}
                  </p>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"orangdash"} />
                  <p className="flex-grow-1">في انتظار التحويل البنكي</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {(
                      parseFloat(
                        fulfillmentData?.payment_requests?.pending_requests
                      ) || 0
                    ).toLocaleString()}
                  </p>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"orangdash"} />
                  <p className="flex-grow-1">
                    <p>اجمالي المبيعات</p>
                    <p>( قابل للسحب + تم التسوية + تم التوصيل )</p>{" "}
                  </p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {(
                      parseFloat(fulfillmentData?.income_report?.total_sales) ||
                      0
                    ).toLocaleString()}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {Number(
                      fulfillmentData?.income_report?.total_sales_count || 0
                    ).toLocaleString()}
                  </small>
                </div>
              </div>
            </>
          ) : (
            // Fulfillment Reports Tab
            <>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"dollarSign"} />
                  <p className="flex-grow-1">
                    {_("panel.total_confirmation_cost")}
                  </p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {Number(
                      reportsData["total_confirmation_price"]
                    ).toLocaleString() || 0}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {Number(
                      reportsData["confirmation_orders_count"] || 0
                    ).toLocaleString()}
                  </small>
                </div>
              </div>{" "}
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"bluecheck"} />
                  <p className="flex-grow-1">{_("panel.cancellation_cost")}</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {Number(
                      reportsData["total_cancellation_price"]
                    ).toLocaleString() || 0}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {Number(
                      reportsData["cancellation_orders_count"] || 0
                    ).toLocaleString()}
                  </small>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"bluetrans"} />

                  <p className="flex-grow-1">{_("panel.handling_cost")}</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {Number(
                      reportsData["total_fulfillment_price"]
                    ).toLocaleString() || 0}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {Number(
                      reportsData["fulfillment_orders_count"] || 0
                    ).toLocaleString()}
                  </small>
                </div>
              </div>
              {/* <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"orangdash"} />

                  <p className="flex-grow-1">{_("home.shippingcost")}</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {Number(
                      reportsData["total_shipping_cost"]
                    ).toLocaleString() || 0}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {Number(
                      reportsData["shipping_orders_count"] || 0
                    ).toLocaleString()}
                  </small>
                </div>
              </div>
              {/* <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"orangdash"} />

                  <p className="flex-grow-1">
                    {_("panel.post_delivery_charge")}
                  </p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {Number(
                      reportsData?.post_delivery_charge || 0
                    ).toLocaleString()}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {Number(
                      reportsData["post_delivery_orders_count"] || 0
                    ).toLocaleString()}
                  </small>
                </div>
              </div> */}
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"orangdash"} />

                  <p className="flex-grow-1">اجمالي تكاليف الخدمات</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {" "}
                    {Number(reportsData?.total_confirmation_price) +
                      Number(reportsData?.total_cancellation_price) +
                      Number(reportsData?.total_fulfillment_price) +
                      Number(reportsData?.total_shipping_cost) +
                      Number(reportsData?.post_delivery_charge)}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {Number(reportsData?.shipping_orders_count) || 0}
                  </small>
                </div> 
              </div> 
            
            </>
          )}
        </div>

        {/* Separator line and Wallet component */}
        {activeTab === "earnings" && (
          <>
            <PaymentRequests />

            {/* <hr
              className="my-4"
              style={{ borderColor: "rgba(23, 43, 77, 0.2)" }}
            /> */}
            {/* <div className="wallet-container container my-3 d-flex flex-column gap-2 position-relative">
              <Loader active={walletLoading} />
              <BlueRow
                values={[
                  statsWallet["total_expected_money"]
                    ? statsWallet["total_expected_money"][0]["stats"] || 0
                    : 0,
                  statsWallet["total_confirmed_money"]
                    ? statsWallet["total_confirmed_money"][0]["stats"] || 0
                    : 0,
                  statsWallet["balance"]
                    ? statsWallet["balance"]["total"] || 0
                    : 0,
                ]}
                slug={alt_name}
                image={statsWallet["image"]}
                titles={[
                  _("panel.expectedearnings"),
                  _("panel.confirmedearnings"),
                  _("panel.withdrawableearnings"),
                ]}
              />
              <OrangeRow
                values={[
                  statsWallet["total_withdrawn_money"]
                    ? statsWallet["total_withdrawn_money"][0]["stats"] || 0
                    : 0,
                  statsWallet["total_earnings"]
                    ? statsWallet["total_earnings"] || 0
                    : 0,
                  statsWallet["total_pending_reqs"]
                    ? statsWallet["total_pending_reqs"][0]["stats"] || 0
                    : 0,
                ]}
                slug={alt_name}
                image={statsWallet["image"]}
              />
            </div> */}
          </>
        )}
      </div>
    </div>
  );
};

export default FulfillmentEarnings;
